<template>
	<div class="recharge-page withdraw big page-padding-top clear">
		<top-bar :title="i18n.t('withdraw.title')" @back="back" ></top-bar>
		
		<div class="form-label">{{i18n.t('withdraw.label1')}}</div>
		<div class="recharge-list">
			<div class="list flex-center" @click="chooseRecharge">
				<div class="name flex-1 flex-center-start">
					<img :src="rechargeInfo.icon" alt="">
					<span>{{rechargeInfo.name}}</span>
				</div>
				<div class="check">
					<img :src="downUrl" alt="">
				</div>
			</div>
		</div>


		<div class="form-label mt-30">{{i18n.t('withdraw.label2')}}</div>
		<div class="recharge-list">
			<div class="list flex-center-between" >
				<template v-if="withdrawInfo.ID">
					<div class="name flex-1 over-text">
						<span>{{withdrawInfo.Address}}</span>
					</div>
					<span class="edit-address" @click.stop="editWithdrawAddress">{{$t('common.edit')}}</span>
				</template>
				<template v-else>
					<span class="empty-desc" @click="chooseWithdraw">
						{{$t('withdraw.label7')}}
					</span>
				</template>
				<div class="check" v-show="!withdrawInfo.ID">
					<Icon name="arrow" size="20" color="#000"></Icon>
				</div>
			</div>
		</div>
	
		<div class="form-label">{{i18n.t('withdraw.label4')}}</div>
		<div class="form-input flex-center-between clear-input" :class="inputActive ? 'active' : ''">
			<input type="number" inputmode="decimal" @focus="inputActive = true"  @blur="inputActive = false" v-model="form.money" :placeholder="i18n.t('withdraw.labelPlaceholder4')">
			<div class="flex-center adot">
				<span class="btn" @click="setAll">{{i18n.t('withdraw.label6')}}</span>
			</div>
		</div>

		<div class="flex-center-start desc-line">
			<div>{{i18n.t('withdraw.label5')}}：</div>
			<div class="count">{{parseFloat(userMoney).toFixed(4)}} </div>
		</div>

		

		<div class="bottom-btn flex-center">
			<Button  class="big" @click="submit">{{i18n.t('withdraw.btn2')}}</Button>
		</div>

		<!--网络类型选择弹窗-->
    <Popup v-model:show="showRecharge" position="bottom" lock-scroll class="rate-popup">
			<div class="rate-modal">
				<div class="title flex-center-between">
					<div>{{i18n.t('withdraw.label8')}}</div>
					<img :src="closeUrl" alt="" @click="cancel">
				</div>
				<div class="recharge-list modal">
          <div class="list flex-center" v-for="(item, i) in rechargeList" :key="i" @click="changeRecharge(item)" :class="rechargeInfoBak.name == item.name  ? 'active' : ''">
            <div class="icon">
              <img :src="item.icon" alt="">
            </div>
            <div class="name flex-1">
              <span>{{item.name}}</span>
            </div>
            <div class="status" v-if="!getAddressByProtocol(item.key)">
              <span class="unbind">{{$t('withdraw.unbind')}}</span>
            </div>
          </div>
				</div>
			</div>
		</Popup>

		<!-- 未绑定地址引导弹窗 -->
		<Popup v-model:show="showBindTips" position="center" lock-scroll class="bind-tips-popup">
			<div class="bind-tips-modal">
				<div class="tips-icon">
					<img :src="warningUrl" alt="">
				</div>
				<div class="tips-title">{{$t('withdraw.bindTipsTitle')}}</div>
				<div class="tips-content">
					{{$t('withdraw.bindTipsContent', {coinType: selectedCoinType})}}
				</div>
				<div class="tips-buttons">
					<Button class="cancel-btn" @click="cancelBindTips">{{$t('common.cancel')}}</Button>
					<Button class="confirm-btn" @click="goToBind">{{$t('withdraw.goToBind')}}</Button>
				</div>
			</div>
		</Popup>
		

	</div>
</template>
<script>
import topBar from '@/components/topBar'
import { Popup, Button, Icon} from 'vant'
import { withdraw, wallet } from '@/api/assest'
import { addressList } from '@/api/setting'
import {formatNumber} from '@/utils/common'
export default {
	components: {
    Popup,
    Button,
		Icon,
		topBar
  },
  data() {
		return {
			form: {
				address: '',
				money: '',
			},
			inputActive: false,
			userMoney: 0,
			closeUrl: require('../../assets/imgs/icon-close.png'),
			backUrl: require('../../assets/imgs/icon-back.png'),
			rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
			downUrl: require('../../assets/imgs/icon-arrow-down3.png'),
			logUrl: require('../../assets/imgs/icon-log.png'),
			warningUrl: require('../../assets/imgs/icon-warning.png'),
			showRecharge: false,
			showBindTips: false,
			selectedCoinType: '',
      rechargeIndex: 0,
			withdrawInfo: {
				ID: '',
				Address: ''
			},
			iconObj:{
        'USDT-TRC20':  require('../../assets/imgs/bit1.png'),
        'USDT-ERC20':  require('../../assets/imgs/bit2.png'),
        'USDC-TRC20':  require('../../assets/imgs/bit5.png'),
        'USDC-ERC20':  require('../../assets/imgs/bit5.png'),
        'ETH-ERC20':  require('../../assets/imgs/bit3.png'),
        'BTC':  require('../../assets/imgs/bit4.png'),
      },
			withdrawInfoBak: {},
			addressData: [],
			rechargeList: [
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDT-TRC20',
					key: 'USDT-TRC20'
				},
				{
					icon: require('../../assets/imgs/bit1.png'),
					name: 'USDT-ERC20',
					key: 'USDT-ERC20'
				},
				{
					icon: require('../../assets/imgs/bit5.png'),
					name: 'USDC-TRC20',
					key: 'USDC-TRC20'
				},
				{
					icon: require('../../assets/imgs/bit5.png'),
					name: 'USDC-ERC20',
					key: 'USDC-ERC20'
				},
				{
					icon: require('../../assets/imgs/bit3.png'),
					name: 'ETH-ERC20',
					key: 'ETH-ERC20'
				},
				{
					icon: require('../../assets/imgs/bit4.png'),
					name: 'BTC',
					key: 'BTC'
				},
			],
			rechargeInfo: {},
			rechargeInfoBak: {},
			addressArr: []
		}
	},
  mounted() {
		this.init()
		this.initAddress()
		let isInit = sessionStorage.getItem('withdrawInit')
		if (isInit == 1) {
			let money = sessionStorage.getItem('withdrawMoney')
			this.form.money = money || ''
			sessionStorage.setItem('withdrawInit', -1)
		}
  },
	methods: {
		init() {
			// 初始化时不获取余额，等用户选择币种后再获取
			// 如果已经选择了币种，则获取对应余额
			if (this.rechargeInfo.key) {
				this.updateBalance()
			}
		},
		// 根据选择的币种获取对应余额
		updateBalance() {
			if (!this.rechargeInfo.key) {
				this.userMoney = 0
				return
			}

			// 将提现地址的key转换为币种简称
			const shortName = this.getShortNameFromKey(this.rechargeInfo.key)
			if (!shortName) {
				this.userMoney = 0
				return
			}

			let form = new FormData()
			form.append('ShortName', shortName)
			form.append('current', 1)
			form.append('pageSize', 10)
			wallet(form).then(res => {
				let data = res.data.Items[0]
				if (data) {
					this.userMoney = formatNumber(data.CapitalUse)
				} else {
					this.userMoney = 0
				}
			}).catch(err => {
				console.error('获取余额失败:', err)
				this.userMoney = 0
			})
		},
		// 将提现地址的key转换为币种简称
		getShortNameFromKey(key) {
			// 币种映射表：提现地址key -> 币种简称
			const keyToShortName = {
				'BTC': 'btc',
				'ETH-ERC20': 'eth',
				'USDT-TRC20': 'usdt',
				'USDT-ERC20': 'usdt',
				'USDC-TRC20': 'usdc',
				'USDC-ERC20': 'usdc'
			}
			return keyToShortName[key] || null
		},
		initAddress() {
      addressList({
        current: 1,
        pageSize: 30
      }).then(res => {
        this.addressArr = res.data.Items
				if (this.addressArr.length > 0) {
					let data = this.addressArr[0]
					this.withdrawInfo = data
					let index = this.rechargeList.findIndex(v => {
						return v.key == data.Protocol
					})
					if (index < 0) {
						index = 0
					}
					this.rechargeInfo = this.rechargeList[index]
					// 初始化地址后更新余额
					this.updateBalance()
				} else {
					this.rechargeInfo = Object.assign({}, this.rechargeList[0])
					// 即使没有地址也要更新余额显示
					this.updateBalance()
				}
      })
    },
		back() {
			this.$router.go(-1)
		},
		toLog() {
			this.$router.push({
				name: 'assestLog',
				query: {
					type: 'withdraw'
				}
			})
		},
		chooseWithdraw() {
			sessionStorage.setItem('withdrawMoney', this.form.money)
			sessionStorage.setItem('bitInfo', JSON.stringify(this.rechargeInfo))
			this.$router.push({
				name: 'addAddress',
			})
    },
		editWithdrawAddress() {
			sessionStorage.setItem('withdrawMoney', this.form.money)
			sessionStorage.setItem('bitInfo', JSON.stringify(this.rechargeInfo))
			this.$router.push({
				name: 'addAddress',
				query: {
					mode: 'edit',
					from: 'withdraw',
					id: this.withdrawInfo.ID,
					protocol: this.withdrawInfo.Protocol || this.rechargeInfo.key,
					address: this.withdrawInfo.Address
				}
			})
		},
		// 根据协议获取对应的地址信息
		getAddressByProtocol(protocol) {
			return this.addressArr.find(item => item.Protocol === protocol)
		},
		submit() {
			if (!this.form.money) {
				this.$toast.fail(this.i18n.t('withdraw.labelPlaceholder4'))
				return
			}
			if (!this.withdrawInfo.ID) {
				this.$toast.fail(this.i18n.t('withdraw.labelPlaceholder2'))
				return
			}

			// 获取当前选择币种的简称
			const shortName = this.getShortNameFromKey(this.rechargeInfo.key)
			if (!shortName) {
				this.$toast.fail('请选择有效的提币币种')
				return
			}

			let form = new FormData()
			form.append('Id', this.withdrawInfo.ID)
			form.append('Price', this.form.money)
			form.append('Type', shortName) // 使用动态币种而不是固定的 'usdt'
			withdraw(form).then(res => {
				if (res.code == 0) {
					this.$toast.success(this.i18n.t('withdraw.success'))
					this.updateBalance() // 提现成功后更新余额
					this.form.money = ''
				} else {
				  this.$toast.fail(res.msg)
				}
			})
		},
		setAll() {
			this.form.money = this.userMoney
		},
		chooseRecharge() {
			this.rechargeInfoBak = Object.assign({}, this.rechargeInfo)
      this.showRecharge = true
    },
    changeRecharge(data) {
			// 检查是否已绑定该币种的地址
			const addressInfo = this.getAddressByProtocol(data.key)

			if (!addressInfo) {
				// 未绑定，显示引导弹窗
				this.selectedCoinType = data.name
				this.showBindTips = true
				this.rechargeInfoBak = data
			} else {
				// 已绑定，直接选择
				this.rechargeInfoBak = data
				this.showRecharge = false
				this.rechargeInfo = Object.assign({}, this.rechargeInfoBak)
				this.withdrawInfo = addressInfo
				// 切换币种后更新余额
				this.updateBalance()
			}
    },
		// 取消绑定提示
		cancelBindTips() {
			this.showBindTips = false
		},
		// 前往绑定地址
		goToBind() {
			this.showBindTips = false
			this.showRecharge = false
			
			// 保存当前输入的信息
			sessionStorage.setItem('withdrawMoney', this.form.money)
			
			// 设置要绑定的币种信息
			sessionStorage.setItem('bitInfo', JSON.stringify(this.rechargeInfoBak))
			
			// 跳转到地址绑定页面
			this.$router.push({
				name: 'addAddress',
				query: {
					from: 'withdraw'
				}
			})
		},
		cancel() {
			this.showRecharge = false
		},
	}
}
</script>

<style scoped>
.recharge-list.modal .list .status {
  margin-right: 10px;
}

.recharge-list.modal .list .status .unbind {
  color: #ff6b6b;
  font-size: 12px;
}

.edit-address {
  color: #2F80ED;
  font-size: 12px;
  margin-left: 10px;
  white-space: nowrap;
}

.bind-tips-popup {
  background: rgba(0, 0, 0, 0.5);
}

.bind-tips-modal {
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 280px;
  text-align: center;
}

.tips-icon {
  margin-bottom: 16px;
}

.tips-icon img {
  width: 48px;
  height: 48px;
}

.tips-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.tips-content {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 24px;
}

.tips-buttons {
  display: flex;
  gap: 12px;
}

.cancel-btn, .confirm-btn {
  flex: 1;
  height: 40px;
  border-radius: 6px;
  font-size: 16px;
}

.cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: none;
}

.confirm-btn {
  background: #1989fa;
  color: white;
  border: none;
}
</style>
